import type { StudioInteractionTab } from '../studio-interaction-capabilities'

interface StudioInteractionTabsProps {
  tabs: StudioInteractionTab[]
  activeTab: StudioInteractionTab
  labels: Record<StudioInteractionTab, string>
  onSelect: (tab: StudioInteractionTab) => void
}

export function StudioInteractionTabs({
  tabs,
  activeTab,
  labels,
  onSelect,
}: StudioInteractionTabsProps) {
  return (
    <div
      data-testid="studio-interaction-tabs"
      className="flex h-10 shrink-0 items-center gap-1 overflow-x-auto border-b border-border bg-card px-2"
    >
      {tabs.map((tab) => {
        const active = tab === activeTab
        return (
          <button
            key={tab}
            type="button"
            data-testid={tab === 'content' ? 'template-content-tab' : undefined}
            aria-pressed={active}
            onClick={() => onSelect(tab)}
            className={`h-7 min-w-0 flex-1 rounded-md px-2 text-xs font-medium transition-colors ${
              active
                ? 'border border-border/70 bg-muted text-foreground'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
          >
            <span className="block truncate">{labels[tab]}</span>
          </button>
        )
      })}
    </div>
  )
}
